import { render } from "./collection-detail-table.vue?vue&type=template&id=1da19dbc&scoped=true"
import script from "./collection-detail-table.vue?vue&type=script&lang=js"
export * from "./collection-detail-table.vue?vue&type=script&lang=js"

import "./collection-detail-table.vue?vue&type=style&index=0&id=1da19dbc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da19dbc"]])

export default __exports__